import { useAppContext } from '../app/app_provider';


export default function useCurrentRoute() {
  const { route } = useAppContext();
  return route;
}
